import { Field, FieldProps, FormikProps } from 'formik'
import * as React from 'react'
import { IFormValues } from '../editrider/personalinfo/PersonalInfoForm'
import { Radio, RadioGroup } from '@mobiscroll/react-latest'

interface IOption {
  value: string
  label: string
}

interface IInnerRadioButtonProps {
  default: IOption
  name: string
  options: IOption[]
}

const InnerRadioButton = (props: IInnerRadioButtonProps) => {
  const getRadioButton = (form: FormikProps<IFormValues>): JSX.Element => {
    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
      form.setFieldValue(props.name, event.target.value)
    }
    const getOption = (opt: IOption) => {
      return (
        <Radio
          value={opt.value}
          checked={opt.value === props.default.value}
          onChange={handleSelect}
          label={opt.label}
        />
      )
    }

    return (
      <RadioGroup className='flex flex-column' name={props.name}>
        {props.options && props.options.map((item: IOption, i) => <div key={item.value}>{getOption(item)}</div>)}
      </RadioGroup>
    )
  }

  return (
    <Field name={props.name}>
      {({ field, form }: FieldProps<IFormValues>) => <div className='mt1'>{getRadioButton(form)}</div>}
    </Field>
  )
}

export default InnerRadioButton



// WEBPACK FOOTER //
// ./src/components/riders/common/InnerRadioButton.tsx